import React from 'react'
import { Link } from 'react-router-dom'
import illustration from '../../icons/blocks.svg'

export default function Empty() {
  return (
    <section className="empty">
      <div>
        <img src={illustration} alt="illustration" />
        <div>Add a goal to get started with your financial plan</div>
        <div>
          Not sure? Start with a <Link to="/templates">sample plan</Link>{' '}
          instead
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/layout/Empty.js